import { Link } from 'react-router-dom'
import PageHero from '@/components/PageHero'
import { Reveal } from '@/components/Reveal'

const partners = [
  {
    name: 'Delta Seed',
    rel: 'Primary Licensee',
    detail:
      "Nearly 100% of Delta Seed's hybrid portfolio originates from Hylix genetics — the deepest commercial validation of the program's work.",
  },
  {
    name: 'Sensako',
    rel: 'Collaborative Development',
    detail: 'Joint hybrid development and testing programs, pairing Hylix germplasm with established commercial evaluation.',
  },
  {
    name: 'Linkseeds',
    rel: 'Strategic Partnership',
    detail: 'Collaborative breeding and germplasm exchange, extending the reach of Hylix lines into new markets.',
  },
  {
    name: 'Maxum Seeds',
    rel: 'Licensed Production',
    detail: 'Hybrid licensing for commercial production and sale under the Maxum brand.',
  },
]

export default function Partners() {
  return (
    <>
      <PageHero eyebrow="Partners" title="Proven in partnership">
        Hylix hybrids and germplasm power some of Southern Africa's most recognised seed brands.
      </PageHero>

      <section className="py-24 md:py-32" style={{ backgroundColor: '#F3F5F1' }}>
        <div className="container-hx grid gap-14 lg:grid-cols-[1fr_1.3fr] lg:gap-20">
          <div>
            <Reveal className="eyebrow">How We Work</Reveal>
            <Reveal as="h2" delay={0.08} className="mt-5 text-[clamp(1.8rem,3.2vw,2.5rem)] font-light leading-[1.2] tracking-[-0.01em] [text-wrap:balance]">
              A foundational seed business
            </Reveal>
            <Reveal as="p" delay={0.16} className="mt-7 leading-[1.85]" style={{ color: '#565650' }}>
              Hylix operates as a <em>basis saad besigheid</em> — a foundational seed business. We
              develop and license hybrids and inbred lines to seed companies for production and
              distribution under their own brands, and produce select Hylix-branded hybrids for
              direct sale.
            </Reveal>
            <Reveal as="p" delay={0.22} className="mt-5 leading-[1.85]" style={{ color: '#565650' }}>
              The arrangement is simple: Hylix does the slow genetic work; partners take it to
              market. The relationships below are measured in years, not transactions.
            </Reveal>
          </div>
          <div className="grid gap-px self-start overflow-hidden sm:grid-cols-2" style={{ backgroundColor: '#D9DED5', border: '1px solid #D9DED5' }}>
            {partners.map((p) => (
              <div key={p.name} className="p-9 transition-colors duration-500 hover:bg-white" style={{ backgroundColor: '#FAFBF9' }}>
                <div className="text-xl font-medium" style={{ color: '#24391C' }}>
                  {p.name}
                </div>
                <div className="mt-2 font-mono-data text-[11px] tracking-[0.06em]" style={{ color: '#C98E33' }}>
                  {p.rel}
                </div>
                <p className="mt-5 text-[14px] leading-[1.8]" style={{ color: '#565650' }}>
                  {p.detail}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-24 md:py-32" style={{ backgroundColor: '#24391C' }}>
        <div className="container-hx mx-auto max-w-2xl text-center">
          <Reveal className="eyebrow" style={{ color: '#8BA872' }}>
            Become a Partner
          </Reveal>
          <Reveal as="h2" delay={0.08} className="mt-5 text-[clamp(1.8rem,3.2vw,2.5rem)] font-light leading-[1.2] text-[#F3F5F1]">
            Work with Hylix
          </Reveal>
          <Reveal as="p" delay={0.16} className="mx-auto mt-6 max-w-xl leading-[1.85] text-[#F3F5F1]/70">
            To license hybrids, access germplasm, or partner on development — speak with us
            directly.
          </Reveal>
          <Reveal delay={0.24} className="mt-10">
            <Link to="/#contact" className="btn-outline-cream">
              Work With Us
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  )
}
